module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAaCAYAAABsONZfAAAAAXNSR0IArs4c6QAAASZJREFUOBGVVLtKA0EUPXeJnY1tipT6AX6BQmwj+BdWVoKgsKAgWNnEv7BIG0E/QOy1tbC1sUtwPJchmSQ3ZzcOLMucxz13ZpgxtI067WKCYxj6SOjx3zXpuUr7FN3xO1zVRFOdOpjinuJTiiMfwNu0gx88Ej9Yrb44L5U8YYJxm8HN1byCt9SSMNPmJF/0L14JluSZYs0/J/kubWjwGobLtMedel9TUEIVDQPJCqJiVl9wEvaknmQF4UldwUm4nJOURMLb+4pwM+LtfTZLIutJTxFuRjxp1CyJbIUb+6DxOVIaybtnOKckadkyk03X9sa0h2VKz8o5dXBG2YuWFqaYaptiGyebGIvJC13YN7ZwxFaHnMk16pv6ryfMExdHvqQDps8fyz8FyTxAJfUilQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cursor-left-round.png
// module id = ihD5
// module chunks = 1